import { render } from "./SimFassetLogoAlt.vue?vue&type=template&id=f8daf94a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__